import React, { useState } from "react";
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";

const storage = getStorage();

export default function EditFundraiserForm({ data, onSave, onCancel }) {
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const [form, setForm] = useState(() => {
        if (!data) return {};
        const donation = Array.isArray(data.donations)
            ? data.donations[0]
            : Object.values(data.donations || {})[0];

        return {
            ...donation,
            id: data.id,
            club_id: data.club_id,

        };
    });
    const handleDeleteImage = async () => {
        const confirmDelete = window.confirm("Are you sure you want to delete this image?");
        if (!confirmDelete) return;

        try {
            const path = decodeURIComponent(new URL(form.image).pathname.split("/o/")[1].split("?")[0]);
            const fileRef = ref(storage, path);
            await fileRef && deleteObject(fileRef); // only delete from storage if available

            setForm((prev) => ({ ...prev, image: "" }));
        } catch (err) {
            console.error("Failed to delete image from storage:", err);
            setError("Failed to delete image.");
        }
    };

    const handlePermissionUpload = async (e) => {
        setUploading(true);
        setError("");
        const file = e.target.files[0];
        if (!file) return;

        const maxSize = 5 * 1024 * 1024; // 5MB
        if (file.size > maxSize) {
            setError("File too large. Max 5MB.");
            setUploading(false);
            return;
        }

        const fileRef = ref(storage, `fundraisers/permission/${uuidv4()}_${file.name}`);
        await uploadBytes(fileRef, file);
        const url = await getDownloadURL(fileRef);

        setForm((prev) => ({ ...prev, permission_url: url }));
        setUploading(false);
    };




    const handleFileUpload = async (e) => {
        setUploading(true);
        setError("");
        const file = e.target.files[0];
        if (!file) return;
        if (file.size > 1024 * 1024) {
            setError("Image too large. Max 1MB.");
            setUploading(false);
            return;
        }

        const fileRef = ref(storage, `fundraisers/${uuidv4()}_${file.name}`);
        await uploadBytes(fileRef, file);
        const url = await getDownloadURL(fileRef);
        setForm((prev) => ({ ...prev, image: url }));
        setUploading(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const dataToSave = {
            id: form.id,
            club_id: form.club_id,
            donations: [form],
            is_active: data?.is_active ?? true, // ✅ ambil nilai asal jika ada

        };
        console.log("Submitting fundraiser data:", dataToSave);
        onSave(dataToSave);
        onCancel(); // close form
    };



    return (
        <form className="edit-form" onSubmit={handleSubmit}>
            <h4>{form.id ? "Edit Fundraiser" : "New Fundraiser"}</h4>
            <input
                name="title"
                value={form.title || ""}
                onChange={handleChange}
                placeholder="Title"
                required
            />
            <textarea
                name="note"
                value={form.note || ""}
                onChange={handleChange}
                placeholder="Note / Description"
                rows={8}
                style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #ccc" }}
            />
            <input
                name="event_name"
                value={form.event_name || ""}
                onChange={handleChange}
                placeholder="Event Name"
            />
            <input
                type="date"
                name="event_date"
                value={
                    form.event_date
                        ? new Date(form.event_date.seconds ? form.event_date.seconds * 1000 : form.event_date).toISOString().split("T")[0]
                        : ""
                }
                onChange={handleChange}
            />
            <input
                name="location"
                value={form.location || ""}
                onChange={handleChange}
                placeholder="Location"
            />
            <input
                name="goal_amount"
                value={form.goal_amount || ""}
                onChange={handleChange}
                placeholder="Goal Amount"
            />

            <label style={{ marginTop: 10 }}>Image:</label>
            <input type="file" accept="image/*" onChange={handleFileUpload} />
            {error && <p style={{ color: "red" }}>{error}</p>}

            {form.image && (
                <div style={{ position: "relative", display: "inline-block" }}>
                    <img src={form.image} alt="Fundraiser" style={{ width: 200, marginTop: 10, borderRadius: 6 }} />
                    <button
                        type="button"
                        onClick={handleDeleteImage}
                        title="Delete Image"
                        style={{
                            position: "absolute",
                            top: -8,
                            right: -8,
                            background: "crimson",
                            color: "white",
                            border: "none",
                            borderRadius: "50%",
                            width: 24,
                            height: 24,
                            cursor: "pointer",
                        }}
                    >
                        &times;
                    </button>
                </div>
            )}

            <div className="form-group">
                <label>Permission Letter (PDF/Image):</label>
                <input type="file" accept=".pdf,image/*" onChange={handlePermissionUpload} />
            </div>

            {form.permission_url && (
                <div style={{ marginTop: 10 }}>
                    <a href={form.permission_url} target="_blank" rel="noopener noreferrer">
                        View uploaded letter
                    </a>
                </div>
            )}

            <div className="participation-buttons" style={{ marginTop: 16 }}>
                <button type="submit" disabled={uploading}>Save</button>
                <button type="button" onClick={onCancel} style={{ marginLeft: 10 }}>Cancel</button>
            </div>
        </form>
    );
}